var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("card", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row mt-4 my-2" }, [
      _c("div", { staticClass: "col-3 my-2" }, [
        _c("h5", [_vm._v(_vm._s(_vm.$t("__ApiLink")))]),
      ]),
      _c("div", { staticClass: "col-9 my-2" }, [
        _c("span", [_vm._v(_vm._s(_vm.apiLink))]),
      ]),
    ]),
    _c("div", { staticClass: "row mt-4 my-2" }, [
      _c("div", { staticClass: "col-3 my-2" }, [
        _c("h5", [_vm._v(_vm._s(_vm.$t("__ClientId")))]),
      ]),
      _c("div", { staticClass: "row col-9 my-2" }, [
        _c(
          "p",
          { staticClass: "mb-2 col-9", attrs: { id: "clientId-title" } },
          [_vm._v(_vm._s(_vm.clientId))]
        ),
        _c(
          "span",
          {
            attrs: { id: "clientId-edit" },
            on: {
              click: function ($event) {
                return _vm.editClientId()
              },
            },
          },
          [_c("i", { staticClass: "fas fa-pencil-alt cursor-pointer pl-1" })]
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.clientId,
              expression: "clientId",
            },
          ],
          staticClass: "form-control mb-2 col-9 element-hide",
          attrs: { type: "text", id: "clientId-input" },
          domProps: { value: _vm.clientId },
          on: {
            keypress: function ($event) {
              return _vm.confirmChangeClientId($event)
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.clientId = $event.target.value
            },
          },
        }),
      ]),
    ]),
    _c("div", { staticClass: "row mt-4 my-2 none" }, [
      _c("div", { staticClass: "col-3 my-2" }, [_c("h5", [_vm._v("Key")])]),
      _c("div", { staticClass: "row col-9 my-2" }, [
        _c("p", { staticClass: "mb-2 col-9", attrs: { id: "key-title" } }, [
          _vm._v(_vm._s(_vm.key)),
        ]),
        _c(
          "span",
          {
            attrs: { id: "key-edit" },
            on: {
              click: function ($event) {
                return _vm.editKey()
              },
            },
          },
          [_c("i", { staticClass: "fas fa-pencil-alt cursor-pointer pl-1" })]
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.key,
              expression: "key",
            },
          ],
          staticClass: "form-control mb-2 col-9 element-hide",
          attrs: { type: "text", id: "key-input" },
          domProps: { value: _vm.key },
          on: {
            keypress: function ($event) {
              return _vm.confirmChangeKey($event)
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.key = $event.target.value
            },
          },
        }),
      ]),
    ]),
    _c("div", { staticClass: "row mt-4 my-2" }, [
      _c("div", { staticClass: "col-3 my-2" }, [
        _c("h5", [_vm._v("payloads")]),
      ]),
      _c(
        "div",
        { staticClass: "col-9 my-2" },
        [
          _vm._l(_vm.payloads, function (payload, pindex) {
            return _c("div", [
              _c("div", { staticClass: "shadow p-3 mb-5 bg-white rounded" }, [
                _c(
                  "div",
                  {
                    staticClass: "badge badge-primary text-wrap",
                    staticStyle: { width: "2rem" },
                  },
                  [_vm._v(" NO " + _vm._s(pindex + 1) + " ")]
                ),
                _c("div", { staticClass: "row mt-4 my-2" }, [
                  _c("div", { staticClass: "col-3 my-2" }, [
                    _vm._v("payload 類型"),
                  ]),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: payload.payload_type,
                          expression: "payload.payload_type",
                        },
                      ],
                      staticClass: "col-4 my-2",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            payload,
                            "payload_type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        { attrs: { value: "kintone", selected: "" } },
                        [_vm._v("kintone 格式")]
                      ),
                      _c("option", { attrs: { value: "single" } }, [
                        _vm._v("單一值"),
                      ]),
                    ]
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-danger float-right",
                    staticStyle: {
                      padding: "2px",
                      "padding-right": "8px",
                      "padding-left": "8px",
                    },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.deletePayload(pindex)
                      },
                    },
                  },
                  [_vm._v("Delete Payload")]
                ),
                payload.payload_type == "single"
                  ? _c("div", [
                      _c("div", { staticClass: "row mt-4 my-2" }, [
                        _c("div", { staticClass: "col-3 my-2" }, [
                          _vm._v("Name"),
                        ]),
                        _c("div", { staticClass: "row col-9 my-2" }, [
                          _c(
                            "p",
                            {
                              staticClass: "mb-2 col-9",
                              attrs: { id: "keyname-" + pindex + "-title" },
                            },
                            [_vm._v(_vm._s(payload.keyname))]
                          ),
                          _c(
                            "span",
                            {
                              attrs: { id: "keyname-" + pindex + "-edit" },
                              on: {
                                click: function ($event) {
                                  return _vm.editUI("keyname-" + pindex)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fas fa-pencil-alt cursor-pointer pl-1",
                              }),
                            ]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: payload.keyname,
                                expression: "payload.keyname",
                              },
                            ],
                            staticClass: "form-control mb-2 col-9 element-hide",
                            attrs: {
                              type: "text",
                              id: "keyname-" + pindex + "-input",
                            },
                            domProps: { value: payload.keyname },
                            on: {
                              keypress: function ($event) {
                                return _vm.confirmUIChangeKey(
                                  $event,
                                  "keyname-" + pindex
                                )
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  payload,
                                  "keyname",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("div", { staticClass: "row mt-4 my-2" }, [
                        _c("div", { staticClass: "col-3 my-2" }, [
                          _vm._v("Key"),
                        ]),
                        _c("div", { staticClass: "row col-9 my-2" }, [
                          _c(
                            "p",
                            {
                              staticClass: "mb-2 col-9",
                              attrs: { id: "key-" + pindex + "-title" },
                            },
                            [_vm._v(_vm._s(payload.key))]
                          ),
                          _c(
                            "span",
                            {
                              attrs: { id: "key-" + pindex + "-edit" },
                              on: {
                                click: function ($event) {
                                  return _vm.editUI("key-" + pindex)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fas fa-pencil-alt cursor-pointer pl-1",
                              }),
                            ]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: payload.key,
                                expression: "payload.key",
                              },
                            ],
                            staticClass: "form-control mb-2 col-9 element-hide",
                            attrs: {
                              type: "text",
                              id: "key-" + pindex + "-input",
                            },
                            domProps: { value: payload.key },
                            on: {
                              keypress: function ($event) {
                                return _vm.confirmUIChangeKey(
                                  $event,
                                  "key-" + pindex
                                )
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(payload, "key", $event.target.value)
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("div", { staticClass: "row mt-4 my-2" }, [
                        _c("div", { staticClass: "col-3 my-2" }, [
                          _vm._v("Value"),
                        ]),
                        _c("div", { staticClass: "row col-9 my-2" }, [
                          _c(
                            "p",
                            {
                              staticClass: "mb-2 col-9",
                              attrs: { id: "keyvalue-" + pindex + "-title" },
                            },
                            [_vm._v(_vm._s(payload.keyvalue))]
                          ),
                          _c(
                            "span",
                            {
                              attrs: { id: "keyvalue-" + pindex + "-edit" },
                              on: {
                                click: function ($event) {
                                  return _vm.editUI("keyvalue-" + pindex)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fas fa-pencil-alt cursor-pointer pl-1",
                              }),
                            ]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: payload.keyvalue,
                                expression: "payload.keyvalue",
                              },
                            ],
                            staticClass: "form-control mb-2 col-9 element-hide",
                            attrs: {
                              type: "text",
                              id: "keyvalue-" + pindex + "-input",
                            },
                            domProps: { value: payload.keyvalue },
                            on: {
                              keypress: function ($event) {
                                return _vm.confirmUIChangeKey(
                                  $event,
                                  "keyvalue-" + pindex
                                )
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  payload,
                                  "keyvalue",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                payload.payload_type == "kintone"
                  ? _c(
                      "div",
                      [
                        _c("div", { staticClass: "row mt-4 my-2" }, [
                          _c("div", { staticClass: "col-3 my-2" }, [
                            _vm._v("App Name"),
                          ]),
                          _c("div", { staticClass: "row col-9 my-2" }, [
                            _c(
                              "p",
                              {
                                staticClass: "mb-2 col-9",
                                attrs: { id: "appName-" + pindex + "-title" },
                              },
                              [_vm._v(_vm._s(payload.app_name))]
                            ),
                            _c(
                              "span",
                              {
                                attrs: { id: "appName-" + pindex + "-edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editUI("appName-" + pindex)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-pencil-alt cursor-pointer pl-1",
                                }),
                              ]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: payload.app_name,
                                  expression: "payload.app_name",
                                },
                              ],
                              staticClass:
                                "form-control mb-2 col-9 element-hide",
                              attrs: {
                                type: "text",
                                id: "appName-" + pindex + "-input",
                                title: "唯一值",
                              },
                              domProps: { value: payload.app_name },
                              on: {
                                keypress: function ($event) {
                                  return _vm.confirmUIChangeKey(
                                    $event,
                                    "appName-" + pindex
                                  )
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    payload,
                                    "app_name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "row mt-4 my-2" }, [
                          _c("div", { staticClass: "col-3 my-2" }, [
                            _vm._v("Domain"),
                          ]),
                          _c("div", { staticClass: "row col-9 my-2" }, [
                            _c(
                              "p",
                              {
                                staticClass: "mb-2 col-9",
                                attrs: { id: "domain-" + pindex + "-title" },
                              },
                              [_vm._v(_vm._s(payload.domain))]
                            ),
                            _c(
                              "span",
                              {
                                attrs: { id: "domain-" + pindex + "-edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editUI("domain-" + pindex)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-pencil-alt cursor-pointer pl-1",
                                }),
                              ]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: payload.domain,
                                  expression: "payload.domain",
                                },
                              ],
                              staticClass:
                                "form-control mb-2 col-9 element-hide",
                              attrs: {
                                type: "text",
                                id: "domain-" + pindex + "-input",
                                title: "唯一値",
                              },
                              domProps: { value: payload.domain },
                              on: {
                                keypress: function ($event) {
                                  return _vm.confirmUIChangeKey(
                                    $event,
                                    "domain-" + pindex
                                  )
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    payload,
                                    "domain",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-3" }),
                          _c("div", { staticClass: "col-9" }, [
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: "is_guest-" + pindex + "-checkbox",
                                },
                              },
                              [_vm._v("是否為訪客空間")]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: payload.is_guest,
                                  expression: "payload.is_guest",
                                },
                              ],
                              staticClass: "ml-3",
                              attrs: {
                                type: "checkbox",
                                id: "is_guest-" + pindex + "-checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(payload.is_guest)
                                  ? _vm._i(payload.is_guest, null) > -1
                                  : payload.is_guest,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = payload.is_guest,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          payload,
                                          "is_guest",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          payload,
                                          "is_guest",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(payload, "is_guest", $$c)
                                  }
                                },
                              },
                            }),
                            _c("br"),
                            _c(
                              "label",
                              {
                                attrs: { for: "guest_id-" + pindex + "-input" },
                              },
                              [_vm._v("訪客空間id")]
                            ),
                            _vm._v("   "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: payload.guest_id,
                                  expression: "payload.guest_id",
                                },
                              ],
                              attrs: {
                                type: "text",
                                id: "guest_id-" + pindex + "-input",
                              },
                              domProps: { value: payload.guest_id },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    payload,
                                    "guest_id",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "row mt-4 my-2" }, [
                          _c("div", { staticClass: "col-3 my-2" }, [
                            _vm._v("識別碼"),
                          ]),
                          _c("div", { staticClass: "row col-9 my-2" }, [
                            _c(
                              "p",
                              {
                                staticClass: "mb-2 col-9",
                                attrs: { id: "id-" + pindex + "-title" },
                              },
                              [_vm._v(_vm._s(payload.id))]
                            ),
                            _c(
                              "span",
                              {
                                attrs: { id: "id-" + pindex + "-edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editUI("id-" + pindex)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-pencil-alt cursor-pointer pl-1",
                                }),
                              ]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: payload.id,
                                  expression: "payload.id",
                                },
                              ],
                              staticClass:
                                "form-control mb-2 col-9 element-hide",
                              attrs: {
                                type: "text",
                                id: "id-" + pindex + "-input",
                              },
                              domProps: { value: payload.id },
                              on: {
                                keypress: function ($event) {
                                  return _vm.confirmUIChangeKey(
                                    $event,
                                    "id-" + pindex
                                  )
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(payload, "id", $event.target.value)
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "row mt-4 my-2" }, [
                          _c("div", { staticClass: "col-3 my-2" }, [
                            _vm._v(_vm._s(_vm.$t("__EndPoint"))),
                          ]),
                          _c("div", { staticClass: "row col-9 my-2" }, [
                            _c(
                              "p",
                              {
                                staticClass: "mb-2 col-9",
                                attrs: { id: "endPoint" + pindex + "title" },
                              },
                              [_vm._v(_vm._s(payload.endpoint))]
                            ),
                            _c(
                              "span",
                              {
                                attrs: { id: "endPoint-" + pindex + "-edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editUI("endPoint-" + pindex)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-pencil-alt cursor-pointer pl-1",
                                }),
                              ]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: payload.endpoint,
                                  expression: "payload.endpoint",
                                },
                              ],
                              staticClass:
                                "form-control mb-2 col-9 element-hide",
                              attrs: {
                                type: "text",
                                id: "endPoint-" + pindex + "-input",
                              },
                              domProps: { value: payload.endpoint },
                              on: {
                                keypress: function ($event) {
                                  return _vm.confirmUIChangeKey(
                                    $event,
                                    "endPoint-" + pindex
                                  )
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    payload,
                                    "endpoint",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "row mt-4 my-2" }, [
                          _c("div", { staticClass: "col-3 my-2" }, [
                            _vm._v("App ID"),
                          ]),
                          _c("div", { staticClass: "row col-9 my-2" }, [
                            _c(
                              "p",
                              {
                                staticClass: "mb-2 col-9",
                                attrs: { id: "appId-" + pindex + "-title" },
                              },
                              [_vm._v(_vm._s(payload.app_id))]
                            ),
                            _c(
                              "span",
                              {
                                attrs: { id: "appId-" + pindex + "-edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editUI("appId-" + pindex)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-pencil-alt cursor-pointer pl-1",
                                }),
                              ]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: payload.app_id,
                                  expression: "payload.app_id",
                                },
                              ],
                              staticClass:
                                "form-control mb-2 col-9 element-hide",
                              attrs: {
                                type: "text",
                                id: "appId-" + pindex + "-input",
                              },
                              domProps: { value: payload.app_id },
                              on: {
                                keypress: function ($event) {
                                  return _vm.confirmUIChangeKey(
                                    $event,
                                    "appId-" + pindex
                                  )
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    payload,
                                    "app_id",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "row mt-4 my-2" }, [
                          _c("div", { staticClass: "col-3 my-2" }, [
                            _vm._v(
                              "Token " + _vm._s(_vm.$t("__tokenComment")) + " "
                            ),
                          ]),
                          _c("div", { staticClass: "row col-9 my-2" }, [
                            _c(
                              "p",
                              {
                                staticClass: "mb-2 col-9",
                                attrs: { id: "token-" + pindex + "-title" },
                              },
                              [_vm._v(_vm._s(payload.token))]
                            ),
                            _c(
                              "span",
                              {
                                attrs: { id: "token-" + pindex + "-edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editUI("token-" + pindex)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-pencil-alt cursor-pointer pl-1",
                                }),
                              ]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: payload.token,
                                  expression: "payload.token",
                                },
                              ],
                              staticClass:
                                "form-control mb-2 col-9 element-hide",
                              attrs: {
                                type: "text",
                                id: "token-" + pindex + "-input",
                              },
                              domProps: { value: payload.token },
                              on: {
                                keypress: function ($event) {
                                  return _vm.confirmUIChangeKey(
                                    $event,
                                    "token-" + pindex
                                  )
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    payload,
                                    "token",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "row mt-4 my-2" }, [
                          _c("div", { staticClass: "col-3 my-2" }, [
                            _vm._v("Behavior"),
                          ]),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: payload.behavior,
                                  expression: "payload.behavior",
                                },
                              ],
                              staticClass: "col-4 my-2",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    payload,
                                    "behavior",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.allBehavior, function (value, index) {
                              return _c(
                                "option",
                                {
                                  key: "behavior-" + index,
                                  domProps: { value: value },
                                },
                                [_vm._v(" " + _vm._s(value) + " ")]
                              )
                            }),
                            0
                          ),
                        ]),
                        _c("div", { staticClass: "row mt-4 my-2" }, [
                          _c("div", { staticClass: "col-3 my-2" }, [
                            _vm._v("Update Key"),
                          ]),
                          _c("div", { staticClass: "row col-9 my-2" }, [
                            _c(
                              "p",
                              {
                                staticClass: "mb-2 col-9",
                                attrs: { id: "updatekey-" + pindex + "-title" },
                              },
                              [_vm._v(_vm._s(payload.updatekey))]
                            ),
                            _c(
                              "span",
                              {
                                attrs: { id: "updatekey-" + pindex + "-edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editUI("updatekey-" + pindex)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-pencil-alt cursor-pointer pl-1",
                                }),
                              ]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: payload.updatekey,
                                  expression: "payload.updatekey",
                                },
                              ],
                              staticClass:
                                "form-control mb-2 col-9 element-hide",
                              attrs: {
                                type: "text",
                                id: "updatekey-" + pindex + "-input",
                              },
                              domProps: { value: payload.updatekey },
                              on: {
                                keypress: function ($event) {
                                  return _vm.confirmUIChangeKey(
                                    $event,
                                    "updatekey-" + pindex
                                  )
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    payload,
                                    "updatekey",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "row mb-2 align-items-center" },
                          [
                            _c("div", { staticClass: "row col-6 my-2" }, [
                              _c("p", { staticClass: "col-9 my-2" }, [
                                _c("b", [
                                  _vm._v("Parameter (can not the same)"),
                                ]),
                              ]),
                            ]),
                            _c("p", { staticClass: "col-4 my-2" }, [
                              _c("b", [_vm._v("Variable")]),
                            ]),
                            _vm.params.length == 0
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "text-info m-1",
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addParameter(pindex)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-plus text-info",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._l(
                          payload.paramsObjectlize,
                          function (param, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "row mb-2" },
                              [
                                _c("div", { staticClass: "row col-6 my-2" }, [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "col-9",
                                      attrs: { id: "param-title-" + param.id },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(param.externalAttribute) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      attrs: { id: "param-edit-" + param.id },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editParameter(param.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-pencil-alt cursor-pointer pl-1",
                                      }),
                                    ]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: param.externalAttribute,
                                        expression: "param.externalAttribute",
                                      },
                                    ],
                                    staticClass:
                                      "form-control col-9 element-hide",
                                    attrs: {
                                      type: "text",
                                      id: "param-input-" + param.id,
                                    },
                                    domProps: {
                                      value: param.externalAttribute,
                                    },
                                    on: {
                                      keypress: function ($event) {
                                        return _vm.confirmChangeParameter(
                                          $event,
                                          param.id
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          param,
                                          "externalAttribute",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: param.userVariable,
                                        expression: "param.userVariable",
                                      },
                                    ],
                                    staticClass: "col-4 my-2",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          param,
                                          "userVariable",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "",
                                          disabled: "",
                                          selected: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "__UserVariableSelectOptional"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.allVariables,
                                      function (value, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: "variable-" + index,
                                            domProps: { value: value },
                                          },
                                          [_vm._v(" " + _vm._s(value) + " ")]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _c("div", { staticClass: "ml-1" }, [
                                  payload.paramsObjectlize.length > 0
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "text-danger m-1",
                                          attrs: { href: "javascript:void(0)" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteParameter(
                                                pindex,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-minus text-danger",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _c("div", { staticClass: "ml-1" }, [
                                  index == payload.paramsObjectlize.length - 1
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "text-info m-1",
                                          attrs: { href: "javascript:void(0)" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addParameter(pindex)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-plus text-info",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ])
          }),
          _c(
            "div",
            {
              staticClass: "row pt-4 add-btn-input cursor-pointer",
              on: {
                click: function ($event) {
                  return _vm.addPayload()
                },
              },
            },
            [
              _c(
                "a",
                {
                  staticClass: "mx-auto my-3",
                  attrs: { href: "javascript:void(0)" },
                },
                [_c("i", { staticClass: "fas fa-plus" })]
              ),
            ]
          ),
        ],
        2
      ),
    ]),
    _c(
      "button",
      {
        staticClass: "btn btn-outline-success pull-right",
        attrs: { "data-translate": "" },
        on: {
          click: function ($event) {
            return _vm.updateAccountExternalApiConfig()
          },
        },
      },
      [_vm._v(" Update ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }